import React, { Component } from 'react';
import { connect } from 'react-redux';
import card from '../../images/icons/ico_cc_def.png';
import cardVisa from '../../images/icons/ico_cc_visa.png';
import { withTranslation } from 'react-i18next'
import { PAYMENT_GATEWAY, CARD_CAN_BE_CHARGED, DEMO, CARD_DEMO, CMSPath, Shift4AvsResultReasons } from '../../../config/constant';
import Loader from '../../UI/loader';
import clientConfigApi from '../../../config/config';
import { setAbortCheckinProcess, setCardStatusPopupProps, setCheckinCurrentPageName } from '../../action/autoCheckin';
import { popupOpenClose, setCheckInAddress } from "../../../action/action";
import { sendAnalytics } from "../../../action/homeAction"
import { getDefaultAnalyticsLabel } from '../../JS/utility';
import $ from "jquery";
import { scrollToTop } from '../../../JS/scrollToTop';

class Shift4_V2 extends Component {

    constructor(props) {
        super(props)
        this.state = {
            showLoader: false,
            IFrameLoading: false,
            disableVerifyButton: false,
            sessionToken: localStorage.getItem("GuestJourneySessionToken"),
            verifyAttempts: 0,
        }

        this.iframeRef = React.createRef();
        this.handleMessageEvent = this.handleMessageEvent.bind(this);
        this.confirmCardWithShift4 = this.confirmCardWithShift4.bind(this);
        this.shiftFourCallback = this.shiftFourCallback.bind(this);
        window.addEventListener("message", this.handleMessageEvent);
    }

    splitFirstandLastName=(fullName)=>{
        const trimmedFullName= fullName.trim();
        const indexToBreak= trimmedFullName.indexOf(" ");
        if(indexToBreak>0){
            return [trimmedFullName.slice(0,indexToBreak), trimmedFullName.slice(indexToBreak+1)];
        }else{
            return [trimmedFullName,""];
        }
    }

    shiftFourCallback = (response) => {

        console.log("shift4: callback response: ", response)

        if (response.status == "SUCCESS") {
            // this.registerClientIP();
            this.props.showLoader(true);

            clientConfigApi.post("/mobileCheckIn/cardValidation", {
                "header": {
                    "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
                    "actionKey": "checks"
                },
                "payload": {
                    "confirmationNumber": this.props.confirmationNumber,
                    "lastNameCard":  this.splitFirstandLastName( response.data.i4go_cardholdername)[1],
                    "cardDigits": response.data.i4go_maskedcard.slice(12, 17),
                    "cardCheckId": response.data.i4go_uniqueid,
                    "cardFullName": response.data.i4go_cardholdername,
                    ...(this.state.isAvsEnable && {
                        isAvsValid: response.data.paymentAPIResults && response.data.paymentAPIResults.CARD_VERIFY.transaction.avs.valid == 'Y'
                    })
                }
            })
                .then((resp) => {

                    if (this.state.isAvsEnable && response.data.paymentAPIResults && response.data.paymentAPIResults.CARD_VERIFY.transaction.avs.valid == 'Y') {
                        const label = getDefaultAnalyticsLabel({
                            appVersion: this.props.installedAppVersion
                                ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`
                                : ""
                        });

                         this.props.sendAnalytics(
                            null,
                            this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                            "AVS - SUCCESS",
                            {
                                ...label,
                                dateTime: new Date,
                                pageName: "CREDIT CARD DETAILS",
                                widgetSessionId: localStorage.getItem("checkinSessionToken"),
                                Room: localStorage.getItem("room") || "",
                                sourceApp: "guestJourneyApp",
                                cardHolderName: response.data.i4go_cardholdername,
                                cardDigits: response.data.i4go_maskedcard,
                                expirationMonth: response.data.i4go_expirationmonth,
                                expirationYear: response.data.i4go_expirationyear
                            },
                            0,
                            false,
                        );
                    }

                    if (resp.status == 200) {
                        clientConfigApi.post("/mobileCheckIn/cardValidation", {
                            "header": {
                                "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
                                "actionKey": "cardUpdate"
                            },
                            "payload": {
                                "confirmationNumber": this.props.confirmationNumber,
                                "cardDigits": response.data.i4go_maskedcard.slice(12, 17),
                                "vaultedCardId": response.data.i4go_uniqueid,
                                "cardTypeCode": this.state.isAvsEnable
                                    ? (response.data.paymentAPIResults && response.data.paymentAPIResults.CARD_VERIFY.card.type) || ""
                                    : (response.data.paymentAPI ? response.data.paymentAPI.card.type: response.data.i4go_cardtype || "" ),
                                "expiryDate":response.data.i4go_expirationmonth  + (response.data.i4go_expirationyear).slice(2,4),
                                "firstNameCard":  this.splitFirstandLastName( response.data.i4go_cardholdername)[0],
                                "lastNameCard":   this.splitFirstandLastName( response.data.i4go_cardholdername)[1],
                           }
                        })
                            .then((res) => {
                                this.props.showLoader(false);
                                if (res.status == 200) {

                                    this.props.setCheckInAddress({...this.props.checkInAddress, addressLine1: response.data.i4go_streetaddress, postalCode: response.data.i4go_postalcode});

                                    this.props.setCardStatusPopupProps({
                                        cardStatus: true,
                                        statusTitle: 'Success',
                                        statusMessage1: 'Card verified successfully',
                                        statusMessage2: 'Please proceed to next steps'
                                    })
                                    this.props.showCardVerified({firstName:this.splitFirstandLastName( response.data.i4go_cardholdername)[0], lastName:this.splitFirstandLastName( response.data.i4go_cardholdername)[1]})
                                    this.props.setcardVerified();
                                    localStorage.setItem("cardVerfied", true)

                                    // Send Analytics
                                    let label = {
                                        "dateTime": new Date,
                                        "appVersion": `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`,
                                        "Room": localStorage.getItem("room") || "",
                                        "sourceApp": "guestJourneyApp",
                                        "layoutTab": this.props.currentHomePage.tabName,
                                        "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                                    }
                                    this.props.sendAnalytics(
                                        null,
                                        this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                                        "CREDIT CARD DETAILS - SUCCESS",
                                        label,
                                        0,
                                        false
                                    );
                                } else {
                                    this.registerClientIP();
                                    this.props.showFailScreen(true, resp.data && resp.data.header && resp.data.header.status.msg || "Unable to check card for the reservation. Please try agian or contact Front Desk");
                                    let failedReason = resp.data && resp.data.header && resp.data.header.status.msg || "Card verification failed"
                                    let label = {
                                        "dateTime": new Date,
                                        "errorMessage": failedReason,
                                        "appVersion": `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`,
                                        "Room": localStorage.getItem("room") || "",
                                        "sourceApp": "guestJourneyApp",
                                        "layoutTab": this.props.currentHomePage.tabName,
                                        "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                                    }
                                    this.props.sendAnalytics(
                                        null,
                                        this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                                        "CREDIT CARD DETAILS - FAILED",
                                        label,
                                        0,
                                        false
                                    );

                                }
                            })
                            .catch((err) => {
                                this.props.showLoader(false);
                                this.registerClientIP();
                                this.props.showFailScreen(true,err.response && err.response.data && err.response.data.header && err.response.data.header.status.msg || "Unable to check card for the reservation. Please try agian or contact Front Desk");

                                // Send Analytics
                                let failedReason = err.response.data && err.response.data.header && err.response.data.header.status.msg || "Card verification failed"
                                let label = {
                                    "dateTime": new Date,
                                    "errorMessage": failedReason,
                                    "appVersion": `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`,
                                    "Room": localStorage.getItem("room") || "",
                                    "sourceApp": "guestJourneyApp",
                                    "layoutTab": this.props.currentHomePage.tabName,
                                    "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                                }
                                this.props.sendAnalytics(
                                    null,
                                    this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                                    "CREDIT CARD DETAILS - FAILED",
                                    label,
                                    0,
                                    false
                                );
                            })
                    } else {
                        this.props.showLoader(false);
                        this.registerClientIP();
                        this.props.showFailScreen(true, resp.data && resp.data.header && resp.data.header.status.msg || "Unable to check card for the reservation. Please try agian or contact Front Desk");
                        let failedReason = resp.data && resp.data.header && resp.data.header.status.msg || "Card verification failed"
                        let label = {
                            "dateTime": new Date,
                            "errorMessage": failedReason,
                            "appVersion": `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`,
                            "Room": localStorage.getItem("room") || "",
                            "sourceApp": "guestJourneyApp",
                            "layoutTab": this.props.currentHomePage.tabName,
                            "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                        }
                        this.props.sendAnalytics(
                            null,
                            this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                            "CREDIT CARD DETAILS - FAILED",
                            label,
                            0,
                            false
                        );
                    }
                })
                .catch((err) => {

                    let errorReason = null;

                    if (this.state.isAvsEnable && response.data.paymentAPIResults && response.data.paymentAPIResults.CARD_VERIFY.transaction.avs.valid !== 'Y') {

                        const avsResultCode = response.data.paymentAPIResults.CARD_VERIFY.transaction.avs.result;
                        errorReason = Shift4AvsResultReasons[avsResultCode] || 'Unknown AVS failure.';


                        const label = getDefaultAnalyticsLabel({
                            appVersion: this.props.installedAppVersion
                                ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`
                                : ""
                        });
                        this.props.sendAnalytics(
                            null,
                            this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                            "AVS - Failed",
                            {
                                ...label,
                                dateTime: new Date,
                                pageName: "CREDIT CARD DETAILS",
                                widgetSessionId: localStorage.getItem("checkinSessionToken"),
                                Room: localStorage.getItem("room") || "",
                                sourceApp: "guestJourneyApp",
                                errorReason: errorReason,
                                avsResultCode: avsResultCode,
                                cardHolderName: response.data.i4go_cardholdername,
                                cardDigits: response.data.i4go_maskedcard,
                                expirationMonth: response.data.i4go_expirationmonth,
                                expirationYear: response.data.i4go_expirationyear
                            },
                            0,
                            false,
                        );
                    }

                    this.props.showLoader(false);
                    this.registerClientIP();
                    console.log(err, "err")

                    if (this.state.isAvsEnable && response.data.paymentAPIResults && response.data.paymentAPIResults.CARD_VERIFY.transaction.avs.valid !== 'Y') {
                        this.props.showFailScreen(true, `Card verification failed: ${errorReason} Please check your billing address or contact the Front Desk for assistance.`);
                    } else {
                        this.props.showFailScreen(true, err.response && err.response.data && err.response.data.header && err.response.data.header.status.msg || "Unable to check card for the reservation. Please try agian or contact Front Desk");
                    }

                    // Send Analytics
                    let failedReason = err.response.data && err.response.data.header && err.response.data.header.status.msg || "Card verification failed"
                    let label = {
                        "dateTime": new Date,
                        "errorMessage": failedReason,
                        "appVersion": `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`,
                        "Room": localStorage.getItem("room") || "",
                        "sourceApp": "guestJourneyApp",
                        "layoutTab": this.props.currentHomePage.tabName,
                        "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                    }
                    this.props.sendAnalytics(
                        null,
                        this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                        "CREDIT CARD DETAILS - FAILED",
                        label,
                        0,
                        false
                    );
                })
        }
        else if (response.status == "FAILURE") {
            this.props.showFailScreen(true, response.data && response.data.error || "");
            this.registerClientIP();
        }
    };

    handleMessageEvent(e) {
        try {
            console.log("Shift4: recieved message from iframe")
            if (e.data && JSON.parse(e.data) && JSON.parse(e.data).status) {
                this.shiftFourCallback(JSON.parse(e.data));
            }
        } catch (error) {
            console.log("error handling message eventlistener")
        }
    }

    confirmCardWithShift4() {
        const maxRetries = this.props.guestValidationMaxRetry || 3;   
        
        if (this.state.verifyAttempts >= maxRetries) {
            this.props.showFailScreen(true, "Maximum Card verification attempts reached.", true);
            return;
        }
    
        this.setState(prevState => ({
            verifyAttempts: prevState.verifyAttempts + 1
        }));
        
        if (this.iframeRef.current) {
            this.iframeRef.current.contentWindow.postMessage('submitClicked', '*');
        } else {
            this.props.showFailScreen(true, "Something went wrong");
        }
    }

    registerClientIP = () => {
        this.setState({ showLoader: true, IFrameLoading: true });

        clientConfigApi.post("/mobileCheckIn/cardValidation", {
            "header": {
                "sessionToken": this.state.sessionToken,
                "actionKey": "register"
            },
            "payload": {
                "confirmationNumber": this.props.confirmationNumber
            }
        }).then(response => {
            if (response.status == 200) {
                this.setState({ showLoader: false, i4go_accessblock: response.data.payload.accessBlock, i4go_server: response.data.payload.server, isAvsEnable: response.data.payload.isAvsEnable })
            }
            else {
                this.setState({ showLoader: false });
                this.props.showFailScreen(true, response.data && response.data.header && response.data.header.status.msg || "Card verification failed");


                let failedReason = response.data && response.data.header && response.data.header.status.msg || "Card verification failed"
                let label = {
                    ...getDefaultAnalyticsLabel({ appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : "" }),
                    "dateTime": new Date,
                    "errorMessage": failedReason, "layoutTab": this.props.currentHomePage.tabName,
                    "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                }

                this.props.sendAnalytics(
                    null,
                    this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                    "CREDIT CARD DETAILS - FAILED",
                    label,
                    0,
                    false
                );

            }

        }).catch(response => {
            this.setState({ showLoader: false })
            this.props.showFailScreen(true, response.data && response.data.header && response.data.header.status.msg || "Card verification failed");
            this.props.backBtn();
            let failedReason = response.data && response.data.header && response.data.header.status.msg || "Card verification failed"
            let label = {
                ...getDefaultAnalyticsLabel({ appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : "" }),
                "dateTime": new Date,
                "errorMessage": failedReason, "layoutTab": this.props.currentHomePage.tabName,
                "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
            }
            this.props.sendAnalytics(
                null,
                this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                "CREDIT CARD DETAILS - FAILED",
                label,
                0,
                false
            );
        });
    }

    componentDidMount() {
        setTimeout(()=>{
            scrollToTop();
          },100)
          
        console.log("shiftFour inside")
        this.registerClientIP();
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.handleMessageEvent);
    }

    componentDidUpdate=()=>{
        if(this.props.abortCheckinProcess){
            this.props.backBtn();
        }
    }
     


    render() {
        const { t } = this.props
        return (
            <div>
                <header className="inner-pages w-footer subpages">
                    <a className="button-back" onClick={this.props.backBtn}></a>
                    <div className="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${this.props.logo}`} />
                        </div>
                        {/* <p className="bold" style={{ color: "inherit" }}>{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
                    </div>


                    {
                    process.env.REACT_APP_NEWER_DESIGN=="true" && 
                    <div class="cancel-check-in" onClick={()=>{this.props.cancelCheckinProcess()}}>
                                <div>Cancel </div>
                                <span style={{}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M15 5L5 15M5 5L15 15" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                </span>
                        </div>
                    }

                </header>
                <section className="widgets padding-0 margin-0 container-bg">

                    <div class="widget-header widget-header-checkin-inner card-validation">
                        { this.props.currentWidgetObj.widgetHeaderImageUrl && 
                            <div class="widget-header-img">
                                <img src={`${CMSPath}${this.props.currentWidgetObj.widgetHeaderImageUrl}`} alt={this.props.currentWidgetObj.displayName} />
                            </div>
                        }

                        {
                            process.env.REACT_APP_NEWER_DESIGN=="true" ?
                            <>
                                <div class="widget-header-title">{t("check_in.verify_card_heading")}</div>
                                <div class="widget-header-subtitle">{t("check_in.verify_card_subheading")}</div>
                             </>
                            :
                                 <div class="widget-header-title">{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div> 

                        }
                    
                       

                    </div>

                    <div className="widgets">
                        <div className="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                            <h2>{t('check_in.booking_details')}</h2>
                        </div>
                        {!(localStorage.getItem('cardVerfied') == 'true') ?
                            <div className="form-window">
                                <div className="form-window-heading">
                                    {t('check_in.card_details')}
                                </div>
                                {!this.state.showLoader ?
                                <div className='row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1'>
                                    <div className='shift4-container-parent'>
                                        {this.state.IFrameLoading && <div class="loader-ring"><img src="layout_2/assests/loader.png" /></div>}
                                        <iframe frameborder="0" onLoad={() => {
                                            this.setState({ IFrameLoading: false });
                                            $(".shift4-container").attr("style", "width: 100%; height: 100%")
                                        }} style={{ width: 0, height: 0 }} ref={this.iframeRef} className='shift4-container' src={`https://guest-journey.s3.amazonaws.com/static/Shift4i4go.html?accessblock=${encodeURIComponent(this.state.i4go_accessblock)}&server=${encodeURIComponent(this.state.i4go_server)}&isDemo=${DEMO}`}></iframe>

                                    </div>
                                    {!this.state.IFrameLoading && <div className="form-controls">
                                        <button disabled={this.state.disableVerifyButton} className="primary w-100" onClick={this.confirmCardWithShift4}>Verify Card</button>
                                    </div>}
                                    {DEMO && <input class="card-skip" onClick={() => this.props.next({ firstName: this.state.firstName, lastName: this.state.lastName })} type="submit" value="Skip" style={{ marginTop: '1rem', color: "#000", backgroundColor: "#fff" }} />}
                                </div>
                                : <Loader close={() => this.setState({ showLoader: false })} displayMsg="Verifying details..." />
                                }
                            </div>
                            :
                            <div class="form-window">
                                <div class="form-window-heading">
                                    Card verified
                                </div>
                                <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                    <div class="form-row margin-bottom-1">
                                        <p>Your card was successfully verified.</p>
                                        <p>Tap on CONTINUE to proceed</p>
                                    </div>
                                    {/* <div class="form-controls">
                                        <button className="primary w-100" onClick={() => this.props.next({ firstName: this.state.firstName, lastName: this.state.lastName })}>{t('check_in.next')}</button>
                                    </div> */}
                                </div>
                            </div>
                        }
                    </div>
                </section>
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        cardChecksData: state.store2.cardChecksData,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        checkInAddress: state.store2.checkInAddress,
        abortCheckinProcess: state.store2.abortCheckinProcess,
        guestValidationMaxRetry: state.store2.cardChecksData.guestValidationMaxRetry,
    }
}

export default connect(mapStateToProps, {
    setCardStatusPopupProps,
    popupOpenClose,
    sendAnalytics,
    setCheckInAddress,
    setCheckinCurrentPageName,
    setAbortCheckinProcess
})(withTranslation('translations')(Shift4_V2));